import React from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import ListReceipt from './listReceipt';
import StatisticalReceipt from './statisticalReceipt';
import { ALL_PERMISSION } from 'constants/permission';
import BasicTabs from 'components/BasicTabs';

const { TabPane } = Tabs;

const ReceiptRegistration = () => {
  const { t: translation } = useTranslation();

  const listTab = [{
    key: "list",
    label :translation("receipt.tab.list"),
    permission: undefined,
    component: <ListReceipt />,
  },
  // {
  //   key: "statistical",
  //   label :translation("receipt.tab.statistical"),
  //   permission: undefined,
  //   component: <StatisticalReceipt />,
  // }
]
  return (
    <BasicTabs tabs={listTab} permissionConstant={ALL_PERMISSION.MANAGE_BILLING.permissionTab} />
  );
};

export default ReceiptRegistration;
